<template>
    <section>
        <div class="wizard">
            <div v-for="(item, i) in steps" :key="i" @click="changeStep(i)">
                <div class="step">
                    <div
                        :class="[
                            'step-box',
                            {
                                active: i == activeStep,
                                success: i < activeStep,
                            },
                        ]"
                    >
                        <span>{{ i + 1 }}</span>
                    </div>
                    <div class="step-desc top" v-if="i == activeStep">
                        <p class="name">{{ $t(item) }}</p>
                    </div>
                </div>
                <div class="step-desc bottom" v-if="i == activeStep">
                    <p class="name">{{ $t(item) }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { globalEvent } from "@/main";

export default {
    data() {
        return {
            next: null,
            activeStep: 0,
            steps: [
                // "Destinations",
                // "Weight & Dimensions",
                // "Contents & Value",
                // "Protection & Insurance",
                "Shipment Details",
                "Cost & Services",
                "Summary",
                // 'Checkout'
            ],
        };
    },
    methods: {
        changeStep(i) {
            if (this.activeStep < i) return;
            this.activeStep = i;
            this.$emit("changed", i);
        },
        clickNext() {
            this.activeStep += 1;
        },
        clickBack() {
            this.activeStep -= 1;
        },
    },
    created() {
        globalEvent.$on("steps", (s) => {
            this.activeStep = s;
        });
    },
    mounted() {
        this.next = document.querySelector(".pagination-next");
    },
};
</script>

<style lang="scss">
.wizard {
    display: flex;
    align-items: flex-start;

    .arrow {
        width: 20px;
        height: 20px;
        margin: 0 0 0 20px;

        &:lang(ar) {
            transform: rotate(180deg);
            margin: 0 20px 0 0;
        }
    }

    .check {
        width: 20px;
        height: 20px;
        margin-top: 13px;
    }

    .step {
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;

        .step-box {
            background: #fafafa;
            border-radius: 10px;
            width: 45px;
            height: 50px;
            font-size: 22px;
            font-weight: bold;
            text-align: center;
            vertical-align: center;
            line-height: 50px;
            margin: 0 5px;

            &.active {
                background: #4952ff85;
                color: #333;
            }

            &.success {
                background: #50e3c285;
                color: #333;
            }
        }
    }

    .step-desc {
        &.top {
            display: block;
        }

        &.bottom {
            display: none;
        }

        .name {
            font-size: 20px;
            margin: 0 15px;
        }

        .desc {
            font-size: 14px;
            color: #777;
        }
    }
}

@media screen and (max-width: 550px) {
    .step-box {
        width: 35px !important;
        height: 40px !important;
        font-size: 18px !important;
        line-height: 40px !important;
    }

    .step-desc {
        padding: 5px 0 25px;

        &.top {
            display: none !important;
        }

        &.bottom {
            display: block !important;
        }

        .name {
            margin: 0 5px !important;
            white-space: nowrap;
            position: absolute;
            left: 0;
            right: 0;
            padding: 0 15px;
            font-size: 20px !important;
        }
    }
}
</style>
